import { Outlet } from 'react-router-dom'
import Sidebar from './Sidebar'
import TopBar from './TopBar'
import SuspendidoScreen from './SuspendidoScreen'
import { ErrorBoundary } from './ErrorBoundary'
import { useConfiguracion } from '@/features/configuracion/hooks'

export default function Layout() {
  const { data: config, isLoading } = useConfiguracion()

  // Mientras carga no bloqueamos (evita flash de pantalla suspendida en carga inicial)
  if (!isLoading && config?.licencia_activa === false) {
    return <SuspendidoScreen />
  }

  return (
    <div className="me-layout">
      <Sidebar />
      <div className="me-main">
        <TopBar />
        <main className="me-content">
          <ErrorBoundary inline>
            <Outlet />
          </ErrorBoundary>
        </main>
      </div>
    </div>
  )
}
